<span class="newProgressCont">
  <span
    class="newProgress"
    [ngStyle]="{ width: GetPercent() + '%' }"
    style="background-color: #0e555c"
  ></span>
  <span class="newProgressMainCount">{{ PercentValue | number: "1.0-0" }}%</span>
</span>
